<template>
  <div id="view-passwordlost" class="view">
    <div class="view__bar">
      <div class="container">
        <div class="row">
          <div class="rowColumn">
            <sapp-back />
            <!-- <span class="bar__title">Restaurar Contraseña</span> -->
          </div>
        </div>
      </div>
    </div>
    <div class="view__content">
      <div class="container">
        <div class="content-body">
          <div class="content">
            <h2 class="subtitle is-size-4">Restaurar Contraseña</h2>
          </div>
          <div v-if="step == 0">
            <div class="content">
              <p>
                Escribe el correo electrónico que utilizas como nombre de
                usuario de Solicitapp.
              </p>
              <form @submit.prevent="verifyEmail">
                <div class="field">
                  <label for="username">Correo Electrónico</label>
                  <input
                    id="username"
                    class="input input-is-fat"
                    type="email"
                    name="username"
                    v-model="username"
                    placeholder="Correo Electrónico"
                  />
                </div>
                <button
                  class="button is-link is-medium"
                  :class="{ 'is-loading': loading }"
                  :disabled="loading || !validEmail"
                >
                  Validar usuario
                </button>
              </form>
            </div>
          </div>

          <div v-if="step == 1">
            <div class="content">
              <p>
                Para continuar necesitas un código de restauración que recibiras
                vía correo electrónico al presionar el siguiente enlace.
              </p>
              <a @click.prevent="generateKey" class="has-text-weight-semibold">
                Enviar código de restauración
              </a>
            </div>
            <form @submit.prevent="verifyKey">
              <div class="field">
                <input
                  type="text"
                  class="input input-is-fat"
                  placeholder="Ingresa el código de restauración"
                  v-model="rpkey"
                />
              </div>
              <button
                class="button is-link is-medium"
                :class="{ 'is-loading': loading }"
                :disabled="loading || rpkey < 1"
              >
                Continuar
              </button>
            </form>
          </div>

          <div v-if="step == 2">
            <div class="content">
              <p>Solo falta que crees tu nueva contraseña.</p>
              <small>Mínimo de 8 caracteres.</small>
            </div>
            <form @submit.prevent="resetPassword">
              <div class="field">
                <input
                  type="password"
                  v-model="password1"
                  class="input input-is-fat"
                  placeholder="Nueva contraseña"
                />
              </div>
              <div class="field">
                <input
                  type="password"
                  v-model="password2"
                  class="input input-is-fat"
                  placeholder="Confirmar contraseña"
                />
              </div>
              <button
                class="button is-medium is-rounded is-primary"
                :class="{ 'is-loading': loading }"
                :disabled="
                  loading || password1.length < 1 || password2.length < 1
                "
              >
                Guardar
              </button>
            </form>
          </div>

          <div v-if="step > 0" class="content stepBack">
            <a @click.prevent="stepBack">Retroceder</a>
          </div>
        </div>

        <router-link :to="{ name: 'login' }" class="back-to-login">
          <span>Volver al inicio de sesión</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { apiService } from "@/_services";
export default {
  name: "password-lost",
  data() {
    return {
      steps: ["email", "code", "change"],
      step: 0,
      loading: false,
      username: null,
      rpkey: "",
      password1: "",
      password2: "",
      validPassword: null
    };
  },
  computed: {
    validEmail() {
      if (this.username) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(this.username);
      }
      return false;
    },
    passwordErrors() {
      let errors = [];
      if (this.password1 != this.password2)
        errors.push("Las contraseñas no coinciden.");
      if (this.password1.length < 8)
        errors.push("La contraseña debe contener al menos 8 caracteres.");
      return errors;
    }
  },
  watch: {
    passwordErrors(val) {
      this.validPassword = !!(val.length == 0);
    }
  },
  methods: {
    stepBack() {
      if (this.step > 0) {
        this.step--;
      }
    },
    alertCustom(message = null) {
      if (!message) return;
      this.$dialog.alert({
        // title: "Title Alert",
        message: message,
        confirmText: "OK!"
      });
    },
    alertCustomError(message = null) {
      this.$dialog.alert({
        // title: "Error",
        message: message ? message : "Something's not good",
        type: "is-danger"
      });
    },
    verifyEmail() {
      if (!this.validEmail) return;
      this.loading = true;
      apiService.auth
        .usernameExist(this.username)
        .then(response => {
          if (response) {
            this.step = 1;
          } else {
            this.alertCustomError(
              "There is no user registered with that email address."
            );
          }
        })
        .catch(error => {
          this.alertCustomError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    generateKey() {
      if (this.username) {
        this.loading = true;
        apiService.auth
          .rpKeyRequest(this.username)
          .then(() => {
            this.alertCustom("Te hemos enviado un correo con el código!");
          })
          .catch(error => {
            this.$store.dispatch("alert/error", error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    verifyKey() {
      this.loading = true;
      apiService.auth
        .rpKeyVerify(this.username, this.rpkey)
        .then(() => {
          this.step = 2;
        })
        .catch(error => {
          this.alertCustomError(error);
          this.rpkey = "";
          this.step--;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPassword() {
      if (this.password1 !== this.password2) {
        this.alertCustomError("Las contraseñas no coinciden.");
        return;
      }
      if (this.password1.length < 8) {
        this.alertCustomError(
          "La contraseña debe contener al menos 8 caracteres."
        );
        return;
      }
      this.loading = true;
      apiService.auth
        .resetPassword(this.username, this.rpkey, this.password1)
        .then(() => {
          this.$dialog.alert({
            message:
              "<strong>¡Cambio de contraseña exitoso!</strong><br>Ya puedes iniciar sesión con tu nueva contraseña.",
            confirmText: "OK!"
          });
          this.$router.push({ name: "login" });
        })
        .catch(error => {
          this.alertCustomError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen {
  #view-passwordlost {
    text-align: center;
    font-size: 0.875rem;

    a:not(button) {
      text-decoration: underline;
    }
    .field {
      margin: 0 auto 2rem;
      label {
        display: none;
      }
    }
    .subtitle {
      margin-top: 2rem;
    }

    .view__content {
      padding: 0;
      .content-head {
        text-align: center;
        padding: 1rem 0;
        margin-bottom: 2rem;
        border-bottom: 1px solid #eee;
      }
      .content-body {
        padding-left: 1.75rem;
        padding-right: 1.75rem;
        padding-bottom: 6rem;
      }
      .back-to-login {
        position: fixed;
        width: 100%;
        height: 3.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        bottom: 0;
        background-color: #fafafa;
        border-top: 1px solid #eee;
        color: #222;
        font-weight: bold;
        text-decoration: none;
      }
    }

    .stepBack {
      margin-top: 1rem;
    }
  }
  @media (max-width: 39.9375em) {
    #view-passwordlost {
      background-color: #fff;
      font-size: 0.875rem;
      font-weight: normal;
    }
  }
  @media (min-width: 40em) {
    #view-passwordlost {
      font-size: 0.9375rem;
      max-width: 30rem;
      height: auto;
      background-color: #fff;
      border-radius: 0.5rem;
      overflow: hidden;
      box-shadow: 0 1px 1rem 0 rgba($color: #000000, $alpha: 0.05);
      .view__content {
        display: flex;
        align-items: center;
        .content-body {
          padding-left: 3rem;
          padding-right: 3rem;
        }
        .back-to-login {
          position: absolute;
        }
      }
    }
  }
}
</style>
